import { FC, useEffect, useMemo, useState } from 'react';
import { Col, Row } from 'antd';
import styles from './index.module.less';
import cs from 'classnames';
import { isArray } from '@lhb/func';
import HeatSwitch from '@/common/components/business/AreaDetailDrawer/components/FirstScreenRight/components/Basic/HeatSwitch';

/**
 * @Description 商圈详情-基本信息栏（横向展示）
 */
const GroupHorizontal: FC<{
  groupName: string;
  list: any;
  active: any;
  onHeatEvent: (val: boolean, item: any) => void;
}> = ({
  groupName,
  list,
  active,
  onHeatEvent,
}) => {

  const [checked, setChecked] = useState<boolean>(false);

  useEffect(() => {
    const curGroupHasSelected = !!(list?.find((item) => item.keyName === active?.keyName));
    if (active?.keyName && !curGroupHasSelected && checked) {
      // 之前选中热力图，现在热力图使用其他字段了，需要取消这个选中
      setChecked(false);
    }
  }, [active, list, checked]);

  const isHeatMap = useMemo(() => {
    return isArray(list) && list.some(itm => !!itm?.isHeatMap);
  }, [list]);

  const onChange = (val: boolean, item?: any) => {
    setChecked(val);
    // const item = list.length === 3 ? list[2] : null; // 约定使用第三个指标的热力图配置
    onHeatEvent?.(val, item);
  };

  return (
    <div className={styles.groupHorizontal}>
      <div className={styles.titleRow}>
        <div className={styles.name}>{groupName}</div>
        {/* 默认第一项500m */}
        {isHeatMap ? <HeatSwitch checked={checked} onChange={(isChecked) => onChange(isChecked, list?.[0])}/> : <></>}
      </div>

      <Row gutter={5} className={styles.listWrapper}>
        {
          list.map((itm, idx) => (
            <Col span={24 / list.length} key={idx}>
              <div className={cs(styles.listItem, itm.keyName === active?.keyName ? styles.active : '')}
                onClick={() => onChange(true, itm)}
              >
                {
                  itm.keyName === active?.keyName ? <div className={styles.iconCon}>
                    <img
                      src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/youth/icon_checkbox_select@2x.png`}
                      width='100%'
                      height='100%'/>
                  </div> : <></>
                }
                <div className={styles.valueRow}>
                  <div className='fs-12 c-222 bold'>{itm?.value || '-'}</div>
                  {
                    itm?.value && itm?.unit ? <div className='fs-12 c-222'>{itm?.unit}</div> : <></>
                  }
                </div>
                <div className={styles.nameRow}>
                  <span className={'fs-12 c-666'}>{itm?.title}</span>
                  {(itm?.basicValue && itm?.tag) ? <div className={styles.tag}>{itm.tag.replace('内', '')}</div> : <></>}
                </div>
              </div>
            </Col>
          ))
        }
      </Row>
    </div>
  );
};

export default GroupHorizontal;
